import React from "react";
import PropTypes from "prop-types";
import ComponentPanel from "../../components/atoms/ComponentPanel/ComponentPanel";
import UserException from "./UserException";
import DefaultErrorView from "./DefaultErrorView";

function WebglErrorView(props) {
  const { componentTitle, error } = props;
  const { message: msg } = error || { message: "" };
  const isWebgl = msg.toLowerCase().indexOf("webgl") > -1;

  return isWebgl ? (
    <div className="varsome-result-fixed">
      <div className="varsome-container">
        <ComponentPanel
          title={componentTitle}
          content={
            <div className="tw-p-2 tw-py-4 tw-font-normal tw-tracking-wide tw-leading-loose tw-text-red-700 tw-text-center">
              Failed to initialize a WebGL context. <br />
              If possible, please ensure that hardware acceleration is enabled
              on your browser settings. <br />
              You can use this
              <a
                href="https://get.webgl.org/"
                className="tw-mx-2"
                rel="noreferrer"
                target="_blank"
              >
                link
              </a>
              to investigate support for your browser.
            </div>
          }
        />
      </div>
    </div>
  ) : (
    <DefaultErrorView {...props} />
  );
}

WebglErrorView.propTypes = {
  componentTitle: PropTypes.string,
  error: PropTypes.instanceOf(UserException).isRequired,
};

WebglErrorView.defaultProps = {
  componentTitle: "",
};

export default WebglErrorView;
